// /home/labdoo/zitech-nexus/frontend/src/pages/admin/TrainingContentsList.tsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { adminTrainingAPI } from '../../services/api';
import './TrainingContentsList.css';

// SVG Icons
const Icons = {
  Back: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  ),
  Plus: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <path d="M12 5V19M5 12H19" />
    </svg>
  ),
  View: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  Edit: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 3L21 7L7 21H3V17L17 3Z" />
    </svg>
  ),
  Delete: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 7H20" />
      <path d="M10 11V16" />
      <path d="M14 11V16" />
      <path d="M5 7L6 19C6 19.5304 6.21071 20.0391 6.58579 20.4142C6.96086 20.7893 7.46957 21 8 21H16C16.5304 21 17.0391 20.7893 17.4142 20.4142C17.7893 20.0391 18 19.5304 18 19L19 7" />
      <path d="M9 7L10 3H14L15 7" />
    </svg>
  ),
  Close: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Spinner: () => (
    <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="tcl-spinner-svg">
      <path d="M12 2v4M12 22v-4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M22 12h-4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
    </svg>
  ),
  Empty: () => (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2L2 7L12 12L22 7L12 2Z" />
      <path d="M2 17L12 22L22 17" />
      <path d="M2 12L12 17L22 12" />
    </svg>
  ),
  Clock: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  Order: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M8 2V6M16 2V6M3 10H21" />
    </svg>
  ),
  Attachment: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
    </svg>
  ),
  Download: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 17L12 21L20 17" />
      <path d="M12 3V15M12 15L8 11M12 15L16 11" />
    </svg>
  ),
  Video: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="2.18" />
      <line x1="8" y1="2" x2="8" y2="22" />
      <line x1="16" y1="2" x2="16" y2="22" />
      <line x1="2" y1="8" x2="22" y2="8" />
      <line x1="2" y1="16" x2="22" y2="16" />
    </svg>
  ),
  Text: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 7V4h16v3" />
      <line x1="9" y1="20" x2="15" y2="20" />
      <line x1="12" y1="4" x2="12" y2="20" />
    </svg>
  ),
  Quiz: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2L2 7L12 12L22 7L12 2Z" />
      <path d="M2 17L12 22L22 17" />
      <path d="M2 12L12 17L22 12" />
    </svg>
  ),
  Assignment: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
    </svg>
  ),
  Time: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  Calendar: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  Check: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2" strokeLinecap="round">
      <path d="M20 6L9 17L4 12" />
    </svg>
  ),
  Bulb: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  File: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
    </svg>
  ),
  User: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Tag: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
      <line x1="7" y1="7" x2="7.01" y2="7" />
    </svg>
  ),
  Play: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="5 3 19 12 5 21 5 3" />
    </svg>
  ),
};

interface TrainingContent {
  id: number;
  content_type: string;
  title: string;
  content: string;
  order: number;
  duration_minutes: number;
  time_limit_minutes: number | null;
  attachments?: any[];
}

const TrainingContentsList: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [module, setModule] = useState<any>(null);
  const [contents, setContents] = useState<TrainingContent[]>([]);
  const [selectedContent, setSelectedContent] = useState<TrainingContent | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedAttachment, setSelectedAttachment] = useState<any>(null);
  const [showPdfModal, setShowPdfModal] = useState(false);

  const parsedModuleId = id ? parseInt(id, 10) : null;

  useEffect(() => {
    if (!id || isNaN(parsedModuleId!)) {
      console.error('Invalid module ID:', id);
      navigate('/dashboard/admin/training/modules');
      return;
    }
    fetchModuleAndContents();
  }, [id]);

  const fetchModuleAndContents = async () => {
    try {
      const moduleRes = await adminTrainingAPI.getModule(parsedModuleId!);
      setModule(moduleRes.data);
      
      const contentsRes = await adminTrainingAPI.getModuleContents(parsedModuleId!);
      setContents(contentsRes.data);
    } catch (error) {
      console.error('Error fetching contents:', error);
      navigate('/dashboard/admin/training/modules');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (contentId: number) => {
    if (window.confirm('Are you sure you want to delete this content?')) {
      try {
        await adminTrainingAPI.deleteContent(contentId);
        fetchModuleAndContents();
      } catch (error) {
        console.error('Error deleting content:', error);
        alert('Failed to delete content');
      }
    }
  };

  const handleViewContent = (content: TrainingContent) => {
    setSelectedContent(content);
    setShowModal(true);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedContent(null);
    document.body.style.overflow = 'auto';
  };

  const handleViewAttachment = (attachment: any) => {
    setSelectedAttachment(attachment);
    setShowPdfModal(true);
    document.body.style.overflow = 'hidden';
  };

  const closePdfModal = () => {
    setShowPdfModal(false);
    setSelectedAttachment(null);
    document.body.style.overflow = 'auto';
  };

  const getContentTypeIcon = (type: string) => {
    switch(type) {
      case 'video': return <Icons.Video />;
      case 'text': return <Icons.Text />;
      case 'quiz': return <Icons.Quiz />;
      case 'assignment': return <Icons.Assignment />;
      default: return <Icons.Text />;
    }
  };

  const getContentTypeLabel = (type: string) => {
    switch(type) {
      case 'video': return 'Video Lesson';
      case 'text': return 'Text Lesson';
      case 'quiz': return 'Quiz';
      case 'assignment': return 'Assignment';
      default: return 'Content';
    }
  };

  const getContentTypeColor = (type: string) => {
    switch(type) {
      case 'video': return '#0ea5e9';
      case 'text': return '#10b981';
      case 'quiz': return '#8b5cf6';
      case 'assignment': return '#f59e0b';
      default: return '#6b7280';
    }
  };

  const getContentTypeBackground = (type: string) => {
    switch(type) {
      case 'video': return '#dbeafe';
      case 'text': return '#d1fae5';
      case 'quiz': return '#ede9fe';
      case 'assignment': return '#fef3c7';
      default: return '#f3f4f6';
    }
  };

  const renderModalContent = (content: TrainingContent) => {
    switch(content.content_type) {
      case 'video':
        let videoUrl = content.content;
        if (videoUrl.includes('youtube.com/watch?v=')) {
          const videoId = videoUrl.split('v=')[1]?.split('&')[0];
          if (videoId) {
            videoUrl = `https://www.youtube.com/embed/${videoId}`;
          }
        } else if (videoUrl.includes('youtu.be/')) {
          const videoId = videoUrl.split('youtu.be/')[1]?.split('?')[0];
          if (videoId) {
            videoUrl = `https://www.youtube.com/embed/${videoId}`;
          }
        }
        return (
          <div className="tcl-video-container">
            <iframe
              src={videoUrl}
              title={content.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="tcl-video-iframe"
            />
          </div>
        );
      
      case 'text':
        return (
          <div className="tcl-modal-text-content">
            {content.content && content.content.trim() && (
              <div className="tcl-user-notes-section">
                <h3 className="tcl-notes-title">
                  <Icons.Text />
                  Notes
                </h3>
                <div className="tcl-user-notes-content">
                  {content.content.split('\n').map((line, idx) => (
                    <p key={idx}>{line}</p>
                  ))}
                </div>
              </div>
            )}
            
            {content.attachments && content.attachments.length > 0 && (
              <div className="tcl-attachments-section">
                <h3 className="tcl-attachments-title">
                  <Icons.Attachment />
                  Attachments
                </h3>
                <div className="tcl-attachments-grid">
                  {content.attachments.map((att: any) => (
                    <div key={att.id} className="tcl-attachment-card" onClick={() => handleViewAttachment(att)}>
                      <div className="tcl-attachment-card-icon">
                        <Icons.File />
                      </div>
                      <div className="tcl-attachment-card-info">
                        <div className="tcl-attachment-card-name">{att.file_name}</div>
                        <div className="tcl-attachment-card-size">{(att.file_size / 1024).toFixed(2)} KB</div>
                      </div>
                      <div className="tcl-attachment-card-preview">
                        <button className="tcl-preview-button">
                          <Icons.View />
                          Preview
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
      
      case 'quiz':
        return (
          <div className="tcl-quiz-content">
            {content.time_limit_minutes && (
              <div className="tcl-time-limit-badge">
                <Icons.Time />
                Time Limit: {content.time_limit_minutes} minutes
              </div>
            )}
            <div 
              className="tcl-formatted-quiz"
              dangerouslySetInnerHTML={{ 
                __html: content.content
                  .replace(/^Question (\d+):/gm, '<div class="tcl-quiz-question"><span class="tcl-question-number">Question $1:</span></div>')
                  .replace(/^A:/gm, '<div class="tcl-quiz-option"><span class="tcl-option-letter">A.</span>')
                  .replace(/^B:/gm, '<div class="tcl-quiz-option"><span class="tcl-option-letter">B.</span>')
                  .replace(/^C:/gm, '<div class="tcl-quiz-option"><span class="tcl-option-letter">C.</span>')
                  .replace(/^D:/gm, '<div class="tcl-quiz-option"><span class="tcl-option-letter">D.</span>')
                  .replace(/^Answer:/gm, `<div class="tcl-quiz-answer"><span class="tcl-answer-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2" strokeLinecap="round"><path d="M20 6L9 17L4 12"/></svg></span> Answer:`)
                  .replace(/^Explanation:/gm, `<div class="tcl-quiz-explanation"><span class="tcl-explanation-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg></span> Explanation:`)
                  .replace(/\n/g, '<br/>')
              }} 
            />
          </div>
        );
      
      case 'assignment':
        return (
          <div className="tcl-assignment-content">
            {content.time_limit_minutes && (
              <div className="tcl-time-limit-badge">
                <Icons.Time />
                Time Limit: {content.time_limit_minutes} minutes
              </div>
            )}
            <div 
              className="tcl-formatted-assignment"
              dangerouslySetInnerHTML={{ 
                __html: content.content
                  .replace(/^Title:/gm, `<div class="tcl-assignment-section"><span class="tcl-assignment-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2L2 7L12 12L22 7L12 2Z"/></svg></span> <strong>Title:</strong>`)
                  .replace(/^Description:/gm, `<div class="tcl-assignment-section"><span class="tcl-assignment-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 7V4h16v3"/><line x1="9" y1="20" x2="15" y2="20"/><line x1="12" y1="4" x2="12" y2="20"/></svg></span> <strong>Description:</strong>`)
                  .replace(/^Requirements:/gm, `<div class="tcl-assignment-section"><span class="tcl-assignment-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2" strokeLinecap="round"><path d="M20 6L9 17L4 12"/></svg></span> <strong>Requirements:</strong>`)
                  .replace(/^Due Date:/gm, `<div class="tcl-assignment-section"><span class="tcl-assignment-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg></span> <strong>Due Date:</strong>`)
                  .replace(/^Submission:/gm, `<div class="tcl-assignment-section"><span class="tcl-assignment-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg></span> <strong>Submission:</strong>`)
                  .replace(/^Evaluation Criteria:/gm, `<div class="tcl-assignment-section"><span class="tcl-assignment-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2L2 7L12 12L22 7L12 2Z"/><path d="M2 17L12 22L22 17"/><path d="M2 12L12 17L22 12"/></svg></span> <strong>Evaluation Criteria:</strong>`)
                  .replace(/\n/g, '<br/>')
              }} 
            />
          </div>
        );
      
      default:
        return (
          <div className="tcl-modal-default-content">
            <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>{content.content}</pre>
          </div>
        );
    }
  };

  if (loading) {
    return (
      <div className="tcl-loading-container">
        <div className="tcl-spinner">
          <Icons.Spinner />
        </div>
        <p className="tcl-loading-text">Loading contents...</p>
      </div>
    );
  }

  if (!module) {
    return (
      <div className="tcl-error-container">
        <div className="tcl-error-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>
        <h2 className="tcl-error-title">Module Not Found</h2>
        <p className="tcl-error-text">The module you're looking for doesn't exist or has been removed.</p>
        <button className="tcl-error-btn" onClick={() => navigate('/dashboard/admin/training/modules')}>
          <Icons.Back />
          Back to Modules
        </button>
      </div>
    );
  }

  const totalDuration = contents.reduce((sum, c) => sum + c.duration_minutes, 0);

  return (
    <div className="tcl-container">
      {/* PDF Preview Modal */}
      {showPdfModal && selectedAttachment && (
        <div className="tcl-pdf-modal-overlay" onClick={closePdfModal}>
          <div className="tcl-pdf-modal" onClick={(e) => e.stopPropagation()}>
            <div className="tcl-pdf-modal-header">
              <h3 className="tcl-pdf-modal-title">
                <Icons.File />
                {selectedAttachment.file_name}
              </h3>
              <button className="tcl-pdf-close" onClick={closePdfModal}>
                <Icons.Close />
              </button>
            </div>
            <div className="tcl-pdf-modal-body">
              <iframe
                src={`${selectedAttachment.file_url}#toolbar=0&navpanes=0`}
                title={selectedAttachment.file_name}
                className="tcl-pdf-iframe"
                frameBorder="0"
              />
            </div>
            <div className="tcl-pdf-modal-footer">
              <a 
                href={selectedAttachment.file_url} 
                download 
                className="tcl-pdf-download-btn"
              >
                <Icons.Download />
                Download
              </a>
              <button className="tcl-pdf-close-btn" onClick={closePdfModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Content Modal */}
      {showModal && selectedContent && (
        <div className="tcl-modal-overlay" onClick={closeModal}>
          <div className="tcl-modal" onClick={(e) => e.stopPropagation()}>
            <div className="tcl-modal-header">
              <h2 className="tcl-modal-title">
                <span className="tcl-modal-icon">{getContentTypeIcon(selectedContent.content_type)}</span>
                {selectedContent.title}
              </h2>
              <button className="tcl-modal-close" onClick={closeModal}>
                <Icons.Close />
              </button>
            </div>
            
            <div className="tcl-modal-body">
              <div className="tcl-modal-meta">
                <span 
                  className="tcl-modal-badge"
                  style={{
                    background: getContentTypeBackground(selectedContent.content_type),
                    color: getContentTypeColor(selectedContent.content_type)
                  }}
                >
                  {getContentTypeIcon(selectedContent.content_type)}
                  {getContentTypeLabel(selectedContent.content_type)}
                </span>
                <span className="tcl-modal-meta-item">
                  <Icons.Clock />
                  {selectedContent.duration_minutes} minutes
                </span>
                {selectedContent.time_limit_minutes && (
                  <span className="tcl-modal-meta-item">
                    <Icons.Time />
                    Time Limit: {selectedContent.time_limit_minutes} minutes
                  </span>
                )}
                <span className="tcl-modal-meta-item">
                  <Icons.Order />
                  Order: {selectedContent.order}
                </span>
              </div>
              
              <div className="tcl-modal-preview">
                {renderModalContent(selectedContent)}
              </div>
            </div>
            
            <div className="tcl-modal-footer">
              <button 
                className="tcl-modal-btn-edit"
                onClick={() => navigate(`/dashboard/admin/training/contents/${selectedContent.id}/edit?moduleId=${id}`)}
              >
                <Icons.Edit />
                Edit Content
              </button>
              <button 
                className="tcl-modal-btn-close"
                onClick={closeModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <div className="tcl-header">
        <div className="tcl-header-left">
          <button 
            className="tcl-back-btn"
            onClick={() => navigate('/dashboard/admin/training/modules')}
          >
            <Icons.Back />
            Back to Modules
          </button>
          <h1 className="tcl-module-title">{module.title}</h1>
          <div className="tcl-module-meta">
            <span className="tcl-module-meta-item">
              <Icons.Tag />
              {module.technology_name}
            </span>
            <span className="tcl-module-meta-divider">|</span>
            <span className="tcl-module-meta-item">
              <Icons.Text />
              {contents.length} lessons
            </span>
            <span className="tcl-module-meta-divider">|</span>
            <span className="tcl-module-meta-item">
              <Icons.Clock />
              {totalDuration} min total
            </span>
          </div>
        </div>
        <button 
          className="tcl-add-btn"
          onClick={() => navigate(`/dashboard/admin/training/modules/${id}/contents/create`)}
        >
          <Icons.Plus />
          Add Content
        </button>
      </div>

      {/* Stats Bar */}
      <div className="tcl-stats-bar">
        <div className="tcl-stat-item">
          <span className="tcl-stat-label">Total Lessons</span>
          <span className="tcl-stat-value">{contents.length}</span>
        </div>
        <div className="tcl-stat-divider"></div>
        <div className="tcl-stat-item">
          <span className="tcl-stat-label">Videos</span>
          <span className="tcl-stat-value tcl-stat-video">{contents.filter(c => c.content_type === 'video').length}</span>
        </div>
        <div className="tcl-stat-divider"></div>
        <div className="tcl-stat-item">
          <span className="tcl-stat-label">Text Lessons</span>
          <span className="tcl-stat-value tcl-stat-text">{contents.filter(c => c.content_type === 'text').length}</span>
        </div>
        <div className="tcl-stat-divider"></div>
        <div className="tcl-stat-item">
          <span className="tcl-stat-label">Quizzes</span>
          <span className="tcl-stat-value tcl-stat-quiz">{contents.filter(c => c.content_type === 'quiz').length}</span>
        </div>
        <div className="tcl-stat-divider"></div>
        <div className="tcl-stat-item">
          <span className="tcl-stat-label">Assignments</span>
          <span className="tcl-stat-value tcl-stat-assignment">{contents.filter(c => c.content_type === 'assignment').length}</span>
        </div>
      </div>

      {/* Contents List */}
      <div className="tcl-contents-list">
        {contents.length === 0 ? (
          <div className="tcl-empty-state">
            <Icons.Empty />
            <h3 className="tcl-empty-title">No Content Yet</h3>
            <p className="tcl-empty-text">Click "Add Content" to create lessons, videos, quizzes, or upload documents for text lessons.</p>
          </div>
        ) : (
          contents.map((content, index) => (
            <div key={content.id} className="tcl-content-item">
              <div className="tcl-content-order">{index + 1}</div>
              <div className="tcl-content-info">
                <div className="tcl-content-header">
                  <span 
                    className="tcl-content-badge"
                    style={{
                      background: getContentTypeBackground(content.content_type),
                      color: getContentTypeColor(content.content_type)
                    }}
                  >
                    {getContentTypeIcon(content.content_type)}
                    {getContentTypeLabel(content.content_type)}
                  </span>
                  <h3 className="tcl-content-title">{content.title}</h3>
                </div>
                <div className="tcl-content-meta">
                  <span className="tcl-meta-item">
                    <Icons.Clock />
                    {content.duration_minutes} minutes
                  </span>
                  {content.time_limit_minutes && (
                    <span className="tcl-meta-item">
                      <Icons.Time />
                      Time Limit: {content.time_limit_minutes} min
                    </span>
                  )}
                  <span className="tcl-meta-item">
                    <Icons.Order />
                    Order: {content.order}
                  </span>
                  {content.attachments && content.attachments.length > 0 && (
                    <span className="tcl-meta-item">
                      <Icons.Attachment />
                      {content.attachments.length} attachment(s)
                    </span>
                  )}
                </div>
                <div className="tcl-content-preview">
                  {content.content_type === 'text' && (
                    <div>
                      {content.content && content.content.length > 0 ? (
                        <div className="tcl-preview-text">
                          {content.content.substring(0, 150)}
                          {content.content.length > 150 ? '...' : ''}
                        </div>
                      ) : (
                        <em className="tcl-no-content">No notes added.</em>
                      )}
                      {content.attachments && content.attachments.length > 0 && (
                        <div className="tcl-attachment-previews">
                          {content.attachments.slice(0, 3).map((att: any) => (
                            <div key={att.id} className="tcl-attachment-preview-item">
                              <Icons.File />
                              <span className="tcl-attachment-name">{att.file_name}</span>
                            </div>
                          ))}
                          {content.attachments.length > 3 && (
                            <div className="tcl-more-attachments">
                              +{content.attachments.length - 3} more
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                  {content.content_type === 'video' && (
                    <div className="tcl-video-preview">
                      <Icons.Play />
                      Video: <span className="tcl-video-url">{content.content?.substring(0, 50)}...</span>
                    </div>
                  )}
                  {content.content_type === 'quiz' && (
                    <div className="tcl-quiz-preview">
                      <Icons.Quiz />
                      Quiz
                      {content.time_limit_minutes && <span className="tcl-time-badge"><Icons.Time /> {content.time_limit_minutes} min</span>}
                    </div>
                  )}
                  {content.content_type === 'assignment' && (
                    <div className="tcl-assignment-preview">
                      <Icons.Assignment />
                      Assignment
                      {content.time_limit_minutes && <span className="tcl-time-badge"><Icons.Time /> {content.time_limit_minutes} min</span>}
                    </div>
                  )}
                </div>
              </div>
              <div className="tcl-content-actions">
                <button 
                  className="tcl-action-btn tcl-action-view"
                  onClick={() => handleViewContent(content)}
                >
                  <Icons.View />
                  View
                </button>
                <button 
                  className="tcl-action-btn tcl-action-edit"
                  onClick={() => navigate(`/dashboard/admin/training/contents/${content.id}/edit?moduleId=${id}`)}
                >
                  <Icons.Edit />
                  Edit
                </button>
                <button 
                  className="tcl-action-btn tcl-action-delete"
                  onClick={() => handleDelete(content.id)}
                >
                  <Icons.Delete />
                  Delete
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default TrainingContentsList;